import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import ApiGo from '../../../actions/ApiGo';
import ConfigHandler from '../../../actions/ConfigHandler';
import { ADD_RESPONSE } from '../../../stores/reducer_add';
import comm_config from './../../../comm_config';
import NotificationTimes, { SpeakTest } from './NotificationTimes';
import VolumnControl from './VolumnControl';

const AlertFilter = () => {
    const dispatch = useDispatch()
    const [day_period, setDay_period] = useState("08:00:00")
    const [mid_period, setMid_period] = useState("16:00:00")
    const [night_period, setNight_period] = useState("00:00:00")
    const [situp_value, setSitup_value] = useState(0)
    const [repeat_value, setRepeat_value] = useState(0)
    const [rotateTime, setRotateTime] = useState(0);
    const [weight, setWeight] = useState(0);
    // i18n翻譯
    const { t } = useTranslation();

    // 過濾選項
    const repeat_filter_option = ["0", "1", "2", "3", "4", "5"]
    const situp_filter_option = ["0", "5", "10", "15", "20"]
    const day_option = ["06:00:00", "07:00:00", "08:00:00", "09:00:00", "10:00:00", "11:00:00", "12:00:00", "13:00:00", "10:00:00", "15:00:00", "16:00:00", "17:00:00", "18:00:00"]
    const mid_option = ["12:00:00", "13:00:00", "14:00:00", "15:00:00", "16:00:00", "10:00:00", "18:00:00", "19:00:00", "20:00:00", "21:00:00", "22:00:00", "23:00:00", "00:00:00"]
    const night_option = ["20:00:00", "21:00:00", "22:00:00", "23:00:00", "00:00:00", "01:00:00", "02:00:00", "03:00:00", "04:00:00", "05:00:00", "06:00:00", "07:00:00", "08:00:00"]

    // 現階段已經time = string的格式了 Date格式已被去除
    // const time_convert =(value)=>{
    //     var time_value = new Date(value * 1000);
    //     var time_zone = time_value.toUTCString();
    //     var time_result = time_zone.slice(-12, -4);
    //     return time_result
    // }
    const time_convert = (value) => {

        let time_value = {
            "6:00:00": "06:00:00",
            "7:00:00": "07:00:00",
            "8:00:00": "08:00:00",
            "9:00:00": "09:00:00",
            "10:00:00": "10:00:00",
            "11:00:00": "11:00:00",
            "12:00:00": "12:00:00",
            "13:00:00": "13:00:00",
            "14:00:00": "14:00:00",
            "15:00:00": "15:00:00",
            "16:00:00": "16:00:00",
            "17:00:00": "17:00:00",
            "18:00:00": "18:00:00",
            "19:00:00": "19:00:00",
            "20:00:00": "20:00:00",
            "21:00:00": "21:00:00",
            "22:00:00": "22:00:00",
            "23:00:00": "23:00:00",
            "0:0:00": "00:00:00",
            "1:00:00": "01:00:00",
            "2:00:00": "02:00:00",
            "3:00:00": "03:00:00",
            "4:00:00": "04:00:00",
            "5:00:00": "05:00:00",
        };
        let result = time_value[value];
        return result
    };

    const start_at_time = (_day, _mid, _night) => {
        ApiGo.putUpdate_Start_At_Time_Admin(_day, _mid, _night)
            .then(() => { dispatch(ADD_RESPONSE({ status: 200, statusText: "success", type: "startat_time" })) })
            .catch((err) => { dispatch(ADD_RESPONSE({ status: err.status, statusText: err.statusText, type: "startat_time" })) })
    }

    useEffect(() => {
        ApiGo.getAll_mac_alert_setting()
            .then((res) => {
                setDay_period(time_convert(res[0].day_start_at))
                setMid_period(time_convert(res[0].mid_start_at))
                setNight_period(time_convert(res[0].night_start_at))
            })
            .catch((err) => { console.log(err) })
    }, [])

    const repeat_filter_put = (mins) => {
        ApiGo.put_update_repeat_alert_filter(mins)
            .then(() => { dispatch(ADD_RESPONSE({ status: 200, statusText: "success", type: "duplicate_alert" })) })
            .catch((err) => { dispatch(ADD_RESPONSE({ status: err.status, statusText: err.statusText, type: "duplicate_alert" })) })
    }
    const sit_up_filter = (mins) => {
        ApiGo.put_update_sit_up_filter(mins)
            .then(() => { dispatch(ADD_RESPONSE({ status: 200, statusText: "success", type: "sit_up_filter" })) })
            .catch((err) => { dispatch(ADD_RESPONSE({ status: err.status, statusText: err.statusText, type: "sit_up_filter" })) })
    }
    useEffect(() => {
        ApiGo.getMac_alert_setting("MAC_ALERT_SETTING")
            .then(res => {
                setRepeat_value(res.data.repeat_alert_filter)
                setSitup_value(res.data.sit_up_filter)
            })
            .catch(err => { console.log(err); })
    }, [])

    const putUpdateK = (_min, _weight) => {
        ApiGo.putUpdate_k(_min, _weight)
            .then(() => { dispatch(ADD_RESPONSE({ status: 200, statusText: "success", type: "upadte_K" })) })
            .catch((err) => { dispatch(ADD_RESPONSE({ status: err.status, statusText: err.statusText, type: "upadte_K" })) })
    }
    useEffect(() => {
        if (rotateTime > 120) {
            setTimeout(() => { alert("久臥時間不建議超過 120 分鐘。") }, [100])
        }
    }, [rotateTime])
    useEffect(() => {
        ApiGo.getMac_alert_setting("MAC_ALERT_SETTING")         // 抓default mac alert setting
            .then(res => {
                setRotateTime(res.data.long_stay_day)
                setWeight(res.data.k_value / res.data.long_stay_day)
            })
            .catch(err => { console.log(err); })
    }, [])

    return (
        <div className='fx-d-r gap20 pad-15 r'>
            <div className='w-50'>
                <NotificationTimes />
                <div className="fx-d-c font-m bgC-white hig-auto br-20 shadow-s-noHover pad-5 t b pad-30 b margb-xxs">
                    <div className="font-l margl-xs h-100 margt-xxs">{t("ADMIN.SHIFT_TIME_SETTINGS")}</div>
                    <div className='font-m margl-xs w-90'>{t("ADMIN.DESCRIPTION")}</div>

                    <div className='fx-d-c fx-ncfs margl-xs pad-15 t fx-cspbt'>
                        <div className='w-100 fx-d-r fx-fsc'>
                            <div className='w-30'>{t("ADMIN.DAY_SHIFT")} :</div>
                            <select className="wid-admin-s font-m bgC-grey" value={day_period} onChange={(e) => setDay_period(e.target.value)}>
                                {day_option.map(mins => {
                                    return <option key={mins} value={mins}>{mins}</option>
                                })}
                            </select>
                            <div className='w-10 fx-ccc'>-</div>
                            <div className='w-10 fx-ccc'>{mid_period || '16:00:00'}</div>
                        </div>
                        <div className='w-100 fx-d-r fx-fsc margt-xs '>
                            <div className='w-30'>{t("ADMIN.NIGHT_SHIFT")} :</div>
                            <select className="wid-admin-s font-m bgC-grey" value={mid_period} onChange={(e) => setMid_period(e.target.value)}>
                                {mid_option.map(mins => {
                                    return <option key={mins} value={mins}>{mins}</option>
                                })}
                            </select>
                            <div className='w-10 fx-ccc'>-</div>
                            <div className='w-10 fx-ccc'>{night_period || '00:00:00'}</div>
                        </div>
                        <div className='w-100 fx-d-r fx-fsc margt-xs'>
                            <div className='w-30'>{t("ADMIN.LATE_NIGHT_SHIFT")} :</div>
                            <select className="wid-admin-s font-m bgC-grey" value={night_period} onChange={(e) => setNight_period(e.target.value)}>
                                {night_option.map(mins => {
                                    return <option key={mins} value={mins}>{mins}</option>
                                })}
                            </select>
                            <div className='w-10 fx-ccc'>-</div>
                            <div className='w-10 fx-ccc'>{day_period || '08:00:00'} </div>
                        </div>
                    </div>
                    <div className='w-70 fx-d-r fx-fec margl-xs font-ml margt-xs'>
                        <div className='br-10 bgC-light pad-15 l r fx-ccc shadow-xs margl-xs'
                            onClick={() => { start_at_time(day_period, mid_period, night_period) }}>{t('GLOBAL.CONFIRM')}</div>
                    </div>
                </div>

                <div className="fx-d-c font-m bgC-white hig-auto br-20 shadow-s-noHover pad-5 t b pad-30 b margb-xxs">
                    <div className="font-l margl-xs h-100 margt-xxs">{t("ADMIN.OTHER_PAGE.DUPLICATE_ALERT_FILTER")}</div>
                    <div className='font-m margl-xs w-90'>{t("ADMIN.OTHER_PAGE.DUPLICATE_ALERT_WARNING")}</div>
                    <div className='fx-d-r margl-xs font-ml w-70 pad-15 t fx-cspbt'>
                        <select className="wid-admin-s font-m bgC-grey" value={repeat_value} onChange={(e) => setRepeat_value(e.target.value)}>
                            {repeat_filter_option.map(mins => {
                                return <option key={mins} value={mins}>{mins}</option>
                            })}
                        </select>
                        <div className='br-10 bgC-light fx-ccc pad-15 l r shadow-xs' onClick={() => { repeat_filter_put(repeat_value) }}>{t('GLOBAL.CONFIRM')}</div>
                    </div>
                </div>
                <div className="fx-d-c font-m bgC-white hig-auto br-20 shadow-s-noHover pad-5 t b pad-30 b margb-xxs">
                    <div className="font-l margl-xs h-100 margt-xxs">{t("ADMIN.OTHER_PAGE.AGITATION_FILTER")}</div>
                    <div className='font-m margl-xs w-90'>{t("ADMIN.OTHER_PAGE.AGITATION_WARNING")}</div>
                    <div className='fx-d-r margl-xs font-ml w-70 pad-15 t fx-cspbt'>
                        <select className="wid-admin-s font-m bgC-grey" value={situp_value} onChange={(e) => setSitup_value(e.target.value)}>
                            {situp_filter_option.map(mins => {
                                return <option key={mins}>{mins}</option>
                            })}
                        </select>
                        <div className='br-10 bgC-light fx-ccc pad-15 l r shadow-xs' onClick={() => { sit_up_filter(situp_value) }}>{t('GLOBAL.CONFIRM')}</div>
                    </div>
                </div>
                {
                    ConfigHandler.isShowAIDC()
                        ? <div className="fx-d-c font-m bgC-white hig-auto br-20 shadow-s-noHover pad-5 t b pad-30 b margb-xxs">
                            <div className="font-l margl-xs h-100 margt-xxs">{t("ADMIN.OTHER_PAGE.PROLONG_BED_REST_K_SETTING")}</div>
                            <div className='margl-xs w-90'>( {t("GLOBAL.WEIGHT")} X {t("ADMIN.OTHER_PAGE.ROTATE_TIME_INTERVAL")} = K ) {t("ADMIN.OTHER_PAGE.KVALUE_WARNING")}</div>
                            <div className='fx-d-c fx-ncfs margl-xs pad-15 t fx-cspbt'>
                                <div className='w-100 fx-d-r fx-fsc'>
                                    <div className='w-30'>{t("ADMIN.OTHER_PAGE.ROTATE_TIME_INTERVAL")} : </div>
                                    <input value={rotateTime} onChange={e => { setRotateTime(e.target.value) }} className="bgC-grey br-20 pad-15 l" />
                                    <div className='w-30'>min</div>
                                </div>
                                <div className='w-100 fx-d-r fx-fsc margt-xs '>
                                    <div className='w-30'>{t("GLOBAL.WEIGHT")} : </div>
                                    <input value={weight} onChange={e => { setWeight(e.target.value) }} className="bgC-grey br-20 pad-15 l" />
                                    <div className='w-30'>Kg</div>
                                </div>
                                <div className='margt-s fx-d-r w-100'>
                                    <div className='w-30'> K =  </div>
                                    <div className='w-30  pad-15 l'>{rotateTime * weight}</div>
                                </div>
                            </div>
                            <div className='w-70 fx-d-r fx-fec margl-xs font-ml margt-xs'>
                                <div className='br-10 bgC-light pad-15 l r fx-ccc shadow-xs margl-xs'
                                    onClick={() => { putUpdateK(rotateTime, weight) }}>{t('GLOBAL.CONFIRM')}</div>
                            </div>
                        </div>
                        : null
                }
            </div>
            <div className='w-50'>
                <VolumnControl />
            </div>
        </div>
    )
}
export default AlertFilter